import type { UserRole } from "../../../../lib/rbac/types.ts";

function hasHrRole(roles: UserRole[]): boolean {
  return roles.includes("HR");
}

/** HR users who also manage employees complete the manager section first. */
export function hasHrAndManagerAccess(roles: UserRole[], isReportingManager: boolean): boolean {
  return hasHrRole(roles) && isReportingManager;
}

/**
 * Manager access is resolved for the selected cycle using its managerId.
 */
export function resolveEditableSectionType(
  roles: UserRole[],
  managerSubmitted?: boolean | null,
  isReportingManager = false,
): "HR" | "MANAGER" | null {
  if (hasHrAndManagerAccess(roles, isReportingManager)) {
    return managerSubmitted === true ? "HR" : "MANAGER";
  }
  if (hasHrRole(roles)) return "HR";
  if (isReportingManager) return "MANAGER";
  return null;
}

export function resolveReviewMode(
  roles: UserRole[],
  managerSubmitted?: boolean | null,
  isReportingManager = false,
): "manager" | "hr" | "superadmin" {
  if (hasHrAndManagerAccess(roles, isReportingManager)) {
    return managerSubmitted === true ? "hr" : "manager";
  }
  if (hasHrRole(roles)) return "hr";
  if (isReportingManager) return "manager";
  return "superadmin";
}
